module.exports = __webpack_public_path__ + "static/img/girl-2.7d5a7dbd.png";